var render = function render(_c,_vm){return _c('span',{staticClass:"base-status",class:[_vm.data.class, _vm.data.staticClass, `${_vm.props.status ? '_' + _vm.props.status : ''}`],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._v(_vm._s(_vm.props.statusText)+" "),(_vm.props.statusComment)?[_vm._v("("+_vm._s(_vm.props.statusComment)+")")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }